import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

function openLink(url) {
  if(Capacitor.getPlatform() == 'web') {
    window.open(url,'_blank')
  } else {
    Browser.open({url})
  }
}

export default openLink
